module.exports = __webpack_public_path__ + "static/media/judge-approved-reverse.1d78db78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/judge-approved-reverse.svg
// module id = 250
// module chunks = 0